import { ReactNode } from 'react';
import styled from 'styled-components';

export const MostRecentWrapper = styled.div`
  margin: 0 -30px;
  font-size: 14px;
`;

export const MostRecentLabel = styled.div`
  font:
    400 10px 'Open Sans',
    sans-serif;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  padding: 10px 30px;
`;

export const MostRecentList = styled.div``;

export const MostRecentItem = styled.div<{ children?: ReactNode }>`
  padding: 20px 30px;

  :nth-child(odd) {
    background-color: ${({ theme }) => theme.palette.backgrounds.primary}};
  }

  :nth-child(even) {
    background-color: ${({ theme }) => theme.palette.backgrounds.main}};
  }
`;

export const MostRecentItemLink = styled.a<{ children?: ReactNode; onClick?: () => void }>`
  color: ${({ theme }) => theme.palette.text.link}};

  :hover {
    cursor: pointer;
  }
`;
